import React from "react";
import { PlayCircle } from "@phosphor-icons/react";

export function toEmbedUrl(url) {
  if (!url) return null;
  let m = url.match(/loom\.com\/(?:share|embed)\/([a-zA-Z0-9]+)/);
  if (m) return `https://www.loom.com/embed/${m[1]}`;
  m = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([\w-]{6,})/);
  if (m) return `https://www.youtube-nocookie.com/embed/${m[1]}`;
  m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (m) return `https://player.vimeo.com/video/${m[1]}`;
  return null;
}

export const StepVideo = ({ url, stepKey, intro = false }) => {
  const src = toEmbedUrl(url);
  if (!src) return null;
  return (
    <div className="mt-6" data-testid={`step-video-${stepKey}`}>
      <div className="flex items-center gap-2 text-sm font-semibold mb-2">
        <PlayCircle size={18} weight="duotone" />
        {intro ? "Watch: what's coming over the next 10 steps" : "Watch: what this step means"}
      </div>
      <div className="relative w-full overflow-hidden rounded-xl border-[1.5px] border-black" style={{ paddingTop: "56.25%" }}>
        <iframe
          src={src}
          title={`Video for ${stepKey}`}
          className="absolute inset-0 w-full h-full"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
};

export default StepVideo;
